import type { AddFieldOption } from '@cli-types/core-engine/add-field.js'
import { parseAddFieldOption } from './parse-add-field-option.js'

export function parseAddFieldOptions(values: string[] | undefined): AddFieldOption[] {
  const options = (values ?? []).map(parseAddFieldOption)
  const seen = new Set<string>()
  for (const option of options) {
    if (seen.has(option.value)) {
      throw new Error(`Duplicate option value "${option.value}".`)
    }
    seen.add(option.value)
  }
  return options
}
